export default "__VITE_ASSET__HQ0HC_Hv__"